import { render, staticRenderFns } from "./SubscriptionEnd.vue?vue&type=template&id=80aa40ac&scoped=true&"
import script from "./SubscriptionEnd.vue?vue&type=script&lang=js&"
export * from "./SubscriptionEnd.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionEnd.vue?vue&type=style&index=0&id=80aa40ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80aa40ac",
  null
  
)

export default component.exports